import { ReactNode } from 'react'
import { FormGroup, Modal } from 'react-bootstrap'
import FormHandler from '../../../utils/Form/FormHandler'
import Field from '../../../utils/Form/Widgets/Field'
import Select from '../../../utils/Form/Widgets/Select'
import { selectOptionsRange } from '../../../utils/utils'

type Props = {
  onHide: () => void
  show: boolean
  itemIdForUpdate?: string
  refreshFunction?: Function
}
class ConversionFactors {
  key?: string
  value?: string
}
class ConversionFactorsEditModal extends FormHandler {
  constructor(props: Props) {
    super(props)
    this.state = { entity: new ConversionFactors() }
  }

  getApiUrl(): string {
    return '/conversion_factors/save/' + this.props.itemIdForUpdate
  }
  getSingleUrl() {
    if (this.props.itemIdForUpdate === 'add') {
      return null
    } else {
      return '/conversion_factors/single/' + this.props.itemIdForUpdate
    }
  }

  getPostData(): object {
    return {
      conversion_factors: this.state.entity,
    }
  }
  render(): ReactNode {
    var state = this.state as any
    return (
      <Modal
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        size='lg'
        show={this.props.show}
        backdrop={true}
        onHide={this.props.onHide}
      >
        <form
          onSubmit={(event) => {
            this.handleSubmit(event).then((response) => {
              if (this.props.refreshFunction) {
                this.props.refreshFunction(response.data.data.entity_id)
              }
            })
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.props.itemIdForUpdate === 'add' ? 'Add' : 'Edit'} Conversion Factor
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <Field
                title='Name'
                className='form-control'
                type='text'
                name='name'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state.entity.name}
              />
              <Select
                title='Year'
                name='year'
                options={selectOptionsRange(2010, 2050)}
                onChange={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state.entity.year}
              />
              <Field
                title='Base Unit'
                className='form-control'
                type='text'
                name='base_unit'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state.entity.base_unit}
              />
              <Field
                title='Target Unit'
                className='form-control'
                type='text'
                name='target_unit'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state.entity.target_unit}
              />
              <Field
                title='Value'
                className='form-control'
                type='text'
                name='value'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state.entity.value}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer className='justify-content-end'>
            {this.props.itemIdForUpdate !== 'add' ? (
              <button
                type='button'
                onClick={(event) => {
                  this.handleDelete(event).then((response) => {
                    if (this.props.refreshFunction) {
                      this.props.refreshFunction('')
                    }
                  })
                }}
                className='btn btn-danger btn-sm'
              >
                <span className='fa fa-trash'></span>
                Delete
              </button>
            ) : (
              <></>
            )}
            <button type='submit' className='btn btn-success btn-sm'>
              <span className='fa fa-floppy-save'></span>
              Save
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export { ConversionFactorsEditModal }
